export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"charset":"utf-8"}],"link":[{"rel":"stylesheet","href":"https://use.typekit.net/mju3jib.css"},{"rel":"preconnect"},{"rel":"dns-prefetch","href":"https://www.googletagmanager.com"},{"rel":"dns-prefetch","href":"https://leadbooster-chat.pipedrive.com"}],"style":[],"script":[{"src":"https://storage.googleapis.com/finmatch-finance-marketing-assets/s/scripts/finmatch-sdk.js?merchantID=M290756&v=1.0","type":"module","async":true},{"src":"//cdn.callrail.com/companies/178401242/686f22f4fe7802f09f5e/12/swap.js","type":"text/javascript","defer":true,"body":true},{"src":"//js-eu1.hs-scripts.com/146717275.js","type":"text/javascript","defer":true,"body":true},{"type":"text/javascript","children":"(function(w,d,t,r,u){\n          var f,n,i;\n          w[u]=w[u]||[];\n          f=function(){\n            var o={ti:\"343150778\", enableAutoSpaTracking: true};\n            o.q=w[u];\n            w[u]=new UET(o);\n            w[u].push(\"pageLoad\")\n          };\n          n=d.createElement(t);\n          n.src=r;\n          n.async=1;\n          n.onload=n.onreadystatechange=function(){\n            var s=this.readyState;\n            if(!s||s===\"loaded\"||s===\"complete\"){\n              f();\n              n.onload=n.onreadystatechange=null;\n            }\n          };\n          i=d.getElementsByTagName(t)[0];\n          i.parentNode.insertBefore(n,i);\n        })(window,document,\"script\",\"//bat.bing.com/bat.js\",\"uetq\");"},{"type":"text/javascript","children":"(function(l,e,a,d,i,n,f,o){\n          if(!l[i]){\n            l.GlobalLeadinfoNamespace=l.GlobalLeadinfoNamespace||[];\n            l.GlobalLeadinfoNamespace.push(i);\n            l[i]=function(){(l[i].q=l[i].q||[]).push(arguments)};\n            l[i].t=l[i].t||n;\n            l[i].q=l[i].q||[];\n            o=e.createElement(a);\n            f=e.getElementsByTagName(a)[0];\n            o.async=1;\n            o.src=d;\n            f.parentNode.insertBefore(o,f);\n          }\n        })(window,document,\"script\",\"https://cdn.leadinfo.net/ping.js\",\"leadinfo\",\"LI-68502F027B6B1\");"},{"type":"text/javascript","children":"(function initApollo(){\n          var n=Math.random().toString(36).substring(7),\n              o=document.createElement(\"script\");\n          o.src=\"https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=\"+n;\n          o.async=true;\n          o.defer=true;\n          o.onload=function(){\n            window.trackingFunctions?.onLoad({ appId:\"696a5337169761001dd83602\" });\n          };\n          document.head.appendChild(o);\n        })();"}],"noscript":[],"viewport":"width=device-width, initial-scale=1.0","htmlAttrs":{"lang":"en","class":"scroll-smooth"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false